'use client';

import React, { ReactNode } from 'react';

import { useConfirmModal } from '@/contexts/ConfirmModalContext';
import Button from '@/components/common/Button';

interface InformationModalContentProps {
  children: ReactNode;
  onClickOKCallback?: () => void;
  propsOKButton?: string;
}

/**
 * OKボタンのみのインフォメーションモーダル（コンテンツ）
 * @param param0
 * @returns
 */
const InformationModalContent: React.FC<InformationModalContentProps> = ({
  children,
  onClickOKCallback,
  propsOKButton
}) => {
  const { closeConfirmModal } = useConfirmModal();

  const handleClickOK = () => {
    if (onClickOKCallback) {
      onClickOKCallback();
    } else {
      closeConfirmModal();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="relative w-full max-w-md max-h-full p-4">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            onClick={closeConfirmModal}>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="p-4 md:p-5 text-center">
            <svg
              className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="mb-8 text-lg font-normal text-gray-500 dark:text-gray-400">{children}</h3>
            <div className="flex justify-center items-center">
              <Button type="button" buttonType="outlinePrimary" onClick={handleClickOK}>
                {propsOKButton != null ? propsOKButton : 'OK'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationModalContent;
